import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Pipes
import { OrderByPipe } from './pipes/sort.pipe';

// Components
import { PermissionsDirective } from './directives/permission.directive';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
  declarations: [
    OrderByPipe,
    PermissionsDirective
  ],
  exports: [
    OrderByPipe,
    PermissionsDirective,
  ]
})
export class SharedModule { }
